import React, { Component } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import { UPDATE } from "react-admin";
import { isEmpty, curry, head, sortBy, compose, prop, isNil, map } from "ramda";
import {
  showNotification,
  SaveButton,
  SimpleForm,
  GET_ONE,
  GET_LIST,
  Button,
  Authenticated
} from "react-admin";

import {
  Select,
  MenuItem,
  InputLabel,
  TextField,
  CardContent,
  LinearProgress,
  Grid,
  Card,
  CardActions
} from "@material-ui/core";

import IconCancel from "@material-ui/icons/Cancel";

import styled from "styled-components";

import NestedGrid from "../components/listBikeHistoryGrid";

import dataProviderFactory from "../dataProvider";
import moment from "moment";

const StyledSpan = styled.div`
  color: red;
  padding: 10px;
  width: 100% !important;
`;

const StyledSelect = styled(Select)`
  width: 256px !important;
`;

class VehicleSwitchActivity extends Component {
  validateDates = () => {
    const { date_1, date_2 } = this.state;
    if (!isEmpty(date_1) && !isEmpty(date_2)) {
      const d2 = moment(date_2);
      const d1 = moment(date_1);
      return d2.isAfter(d1);
    }
    return true;
  };

  async fetchVehicle(id) {
    const dataProvider = await dataProviderFactory("rest");
    const vehicle = await dataProvider(GET_ONE, `bikes_available_to_switch`, {
      id
    });
    return vehicle.data;
  }

  handleCloseClick = () => {
    const { history } = this.props;
    history.replace(`/vehicles`);
  };

  handleItemChange = element => {
    this.setState({ new_vehicle_id: element.target.value, events2: [] }, () => {
      this.updateState();
    });
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    submit("bike-switch-update");
  };

  handleSubmit = async () => {
    const bodyRequest = {
      id: this.props.match.params.id,
      data: {
        id: this.props.match.params.id,
        date_start: this.state.date_1,
        date_end: this.state.date_2,
        new_vehicle_id: this.state.new_vehicle_id
      }
    };
    const dataProvider = await dataProviderFactory("rest");
    dataProvider(UPDATE, "bikes_available_to_switch", bodyRequest)
      .then(() => {
        this.setState({
          date_1: null,
          date_2: null,
          events1: [],
          events2: [],
          availableItems: null,
          new_vehicle_id: 0
        });
        const { history } = this.props;
        history.replace(`/vehicles`);
      })
      .catch(error => {
        showNotification(error.message, "error");
      });
  };

  handleDataChange = (element, type) => {
    this.setState(
      {
        [type]: element.target.value,
        events1: [],
        events2: [],
        availableItems: null,
        new_vehicle_id: 0
      },
      () => {
        this.updateState();
      }
    );
  };

  isBeforeDate1 = curry((date1, date2) =>
    moment(date1).isBefore(moment(date2))
  );

  isAfterDate2 = curry((date2, date1) => moment(date2).isAfter(moment(date1)));

  intersectsOrIsContainedInInterval = (date1, date2, eventDate1, eventDate2) => {
    date1 = moment(date1);
    date2 = moment(date2);
    eventDate1 = moment(eventDate1);
    eventDate2 = moment(eventDate2);

    return ((eventDate1.isSameOrBefore(date2) || eventDate2.isSameOrBefore(date2)) &&
      (eventDate1.isSameOrAfter(date1) || eventDate2.isSameOrAfter(date1)));
  };

  intersectsAndIsNotContainedInInterval = (date1, date2, eventDate1, eventDate2) => {
    date1 = moment(date1);
    date2 = moment(date2);
    eventDate1 = moment(eventDate1);
    eventDate2 = moment(eventDate2);

    return ((eventDate1.isBefore(date1) && eventDate2.isSameOrAfter(date1) && eventDate2.isSameOrBefore(date2)) ||
      (eventDate1.isSameOrAfter(date1) && eventDate1.isSameOrBefore(date2) && eventDate2.isAfter(date2)) ||
      (eventDate1.isBefore(date1) && eventDate2.isAfter(date2)));
  };

  validateTimeInterval = (allEvents, date1, date2) => {
    let result = { result: true, message: '' };
    let stop = false;
    const eventTypes = Object.keys(allEvents);

    eventTypes.forEach(eventType => {
      allEvents[eventType].forEach(event => {
        switch (eventType) {
          case "rentals":
            if (this.intersectsAndIsNotContainedInInterval(date1, date2, event.date_1, event.date_2)) {
              result = { result: false, message: `There is a rental (${event.id}) pending on the selected time interval.` }
              stop = true
            }
            break;
          case "transfers":
            if (this.intersectsAndIsNotContainedInInterval(date1, date2, event.transfer_date, event.setup_date)) {
              result = { result: false, message: `There is a transfer (${event.id}) pending on the selected time interval.` }
              stop = true
            }
            break;
          case "holds":
            if (this.intersectsOrIsContainedInInterval(date1, date2, event.start_date, event.end_date)) {
              result = { result: false, message: `There is a hold (${event.id}) on the selected time interval.` }
              stop = true
            }
            break;
          case "guideBike":
            if (this.intersectsOrIsContainedInInterval(date1, date2, event.tour_start_date, event.tour_end_date)) {
              result = { result: true, message: `There is a Guide Bike (${event.id}) on the selected time interval.` }
              stop = true
            }
            break;
          default:
            break;
        }
        if (stop) {
          return;
        }
      });
      if (stop) {
        return;
      }
    });

    return result
  };

  buildStructure = (allItems, date1, date2) => {
    const structure = [];
    const mainKeys = Object.keys(allItems);

    const holdTypes = {
      0: "Regular",
      1: "New Bike",
      2: "Break In",
      3: "Sale"
    };
    let tam = this.state.data.count;
    mainKeys.map(eventKey => {
      allItems[eventKey].map(event => {
        switch (eventKey) {
          case "rentals":
            if (this.intersectsOrIsContainedInInterval(date1, date2, event.date_1, event.date_2)) {
              structure.push({
                itemKey: tam,
                km: this.state.data.vehicle_mileage,
                description: `${event.type === 2 ? "Rental" : "Tour"} ${event.id
                  }`,
                title: `${event.booking.r_first_name} ${event.booking.r_last_name}`,
                date1: event.date_1,
                date2: event.date_2,
                location1: event.location_1
                  ? event.location_1.location_name
                  : "",
                location_id_1: event.location_1 ? event.location_1.id : "",
                cellLocation2Color: "",
                location2: event.location_2.location_name,
                location_id_2: event.location_2 ? event.location_2.id : "",
                bgColor: event.location_1
                  ? event.location_1.color
                  : event.location_2.color,
                bgColor2: event.location_2
                  ? event.location_2.color
                  : event.location_1.color,
                key: `${eventKey}_${event.id}`
              });
            }
            break;
          case "transfers":
            if (this.intersectsOrIsContainedInInterval(date1, date2, event.transfer_date, event.setup_date)) {
              structure.push({
                itemKey: tam,
                km: this.state.data.vehicle_mileage,
                description: `Transfer ${event.id}`,
                title: `Transfer`,
                date1: moment(event.transfer_date).format("YYYY-MM-DD"),
                date2: moment(event.setup_date).format("YYYY-MM-DD"),
                location1: event.location_1
                  ? event.location_1.location_name
                  : "",
                location_id_1: event.location_1 ? event.location_1.id : "",
                cellLocation2Color: event.location_2.color,
                location2: event.location_2.location_name,
                location_id_2: event.location_2 ? event.location_2.id : "",
                bgColor2: event.location_2
                  ? event.location_2.color
                  : event.location_1.color,
                bgColor: event.location_1
                  ? event.location_1.color
                  : event.location_2.color,
                key: `${eventKey}_${event.id}`
              });
            }
            break;
          case "holds":
            if (this.intersectsOrIsContainedInInterval(date1, date2, event.start_date, event.end_date)) {
              structure.push({
                itemKey: tam,
                km: this.state.data.vehicle_mileage,
                description: `${'Hold'} ${event.id}`,
                title: `${holdTypes[event.hold_type] || 'Other'}`,
                date1: event.start_date,
                date2: event.end_date,
                bgColor: '#FFFFFF',
                bgColor2: '#FFFFFF',
                key: `${eventKey}_${event.id}`
              });
            }
            break;
          case "guideBike":
            if (this.intersectsOrIsContainedInInterval(date1, date2, event.tour_start_date, event.tour_end_date)) {
              structure.push({
                itemKey: tam,
                km: this.state.data.vehicle_mileage,
                description: `${'Bike '} ${this.state.data.licence_plate} `,
                title: `Guide Bike`,
                date1: event.tour_start_date,
                date2: event.tour_end_date,
                location1: event.locationName1,
                location_id_1: event.location_1,
                location_id_2: event.location_2,
                location2: event.locationName2,
                bgColor: '#66CCFF',
                bgColor2: '#66CCFF',
                key: `${eventKey}_${event.id}`
              });
            }
            break;
          default:
            break;
        }
      });
    });
    return structure;
  };

  async fetchAvailableVehicles(modelId, vehicleId, location, date1, date2) {
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_LIST, "bikes_available_to_switch", {
      filter: { modelId, vehicleId, date1, date2, location },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });
    let arrayVehicle = response.data
    const removeIndexInicial = arrayVehicle.filter( item => item.id != vehicleId );
    return removeIndexInicial; 
  }

  async componentDidUpdate(prevProps, prevState) {
    // await this.updateState(prevProps, prevState);
  }

  async componentDidMount() {
    await this.updateState();
  }

  updateState = async (prevProps, prevState) => {
    if (isEmpty(this.state.data)) {
      const { id } = this.props.match.params;
      const data = await this.fetchVehicle(id);
      this.setState({
        data
      });
      console.log('primer')
    }

    if (
      !isEmpty(this.state.data) &&
      !isEmpty(this.state.date_1) &&
      !isEmpty(this.state.date_2) &&
      !isNil(prevState) &&
      (prevState.date_1 !== this.state.date_1 ||
        prevState.date_2 !== this.state.date_2)
    ) {
      console.log('segundo')
      const intervalValidity = this.validateTimeInterval(
        {
          rentals: this.state.data.rentals,
          holds: this.state.data.holds,
          transfers: this.state.data.transfers,
          guideBike: this.state.data.guideBike
        },
        this.state.date_1,
        this.state.date_2
      );
      this.setState({
        intervalValidity
      });
    }

    if (
      isEmpty(this.state.events1) &&
      !isEmpty(this.state.date_1) &&
      !isEmpty(this.state.date_2)
    ) {
      console.log('tercer')
      const events1 = this.buildStructure(
        {
          rentals: this.state.data.rentals,
          holds: this.state.data.holds,
          transfers: this.state.data.transfers,
          guideBike: this.state.data.guideBike
        },
        this.state.date_1,
        this.state.date_2
      );
      const { vehicle_model_id, id } = this.state.data;
      const { date_1, date_2 } = this.state;
      const firstEvent = head(events1);
      console.log(firstEvent)
      //const location = head(events1).location_id_1 ; 
      let location = ''
      if( typeof(firstEvent) !== 'undefined' )
        { location = firstEvent.location_id_1; }
      let availableItems = await this.fetchAvailableVehicles(
        vehicle_model_id,
        id,
        location,
        date_1,
        date_2
      ); 
      if (!isEmpty(events1)) {
        this.setState({ availableItems: availableItems, 
          events1: sortBy(compose(moment, prop("date1")), events1)
        });
      }
    }

    if (this.state.intervalValidity.result === true && !isEmpty(this.state.events1) && isNil(this.state.availableItems)) {
      const { vehicle_model_id, id } = this.state.data;
      const { date_1, date_2, events1 } = this.state;
      const firstEvent = head(events1);
      const location = head(events1).location_id_1; 
      console.log('cuarto')
      let availableItems = await this.fetchAvailableVehicles(
        vehicle_model_id,
        id,
        location,
        date_1,
        date_2
      );
      this.setState({
        availableItems
      });
    }
    //carga cuando se selecciona segunda moto para el swith
    if (this.state.intervalValidity.result === true && isEmpty(this.state.events2) && this.state.new_vehicle_id > 0) {
      const data = await this.fetchVehicle(this.state.new_vehicle_id);
      console.log('quinto ')
      const events2 = this.buildStructure(
        {
          rentals: data.rentals,
          holds: data.holds,
          transfers: data.transfers,
          guideBike: data.guideBike
        },
        this.state.date_1,
        this.state.date_2
      );
      console.log(events2)
      if (!isEmpty(events2)) {
        this.setState({ 
          events2: sortBy(compose(moment, prop("date1")), events2)
        });
      }
    }
  };

  state = {
    data: {},
    data1: {},
    date_1: "",
    date_2: "",
    events1: [],
    events2: [],
    new_vehicle_id: 0,
    error: false,
    newItem: 0,
    availableItems: null,
    intervalValidity: { result: false, message: '' }
  };

  render() {
    const {
      date_1,
      date_2,
      data,
      events1,
      events2,
      availableItems,
      new_vehicle_id,
      intervalValidity
    } = this.state;

    const { isSubmitting } = this.props;
    let validInterval = intervalValidity.result
    return (
      <Authenticated location="/vehiclwes">
        <Card>
          <CardContent>
            <b>
              <h3>Switch activity for {data.licence_plate} {data.renting ? "®" : ""}</h3>
            </b>
            <SimpleForm
              form="bike-switch-update"
              resource="bikes_available_to_switch"
              onSubmit={this.handleSubmit}
              toolbar={null}
            >
              <InputLabel shrink htmlFor="date_1-simple">
                Start Date *
              </InputLabel>
              <br />
              <TextField
                id="date_1"
                type="date"
                onChange={e => this.handleDataChange(e, "date_1")}
                defaultValue={date_1}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{ inputProps: { min: moment().format("YYYY-MM-DD") } }}
              />
              {date_1 === "" && (
                <StyledSpan>* Please select Start date</StyledSpan>
              )}
              <br />
              <InputLabel shrink htmlFor="date_2-simple">
                End Date *
              </InputLabel>
              <br />
              <TextField
                id="date_2"
                type="date"
                onChange={e => this.handleDataChange(e, "date_2")}
                defaultValue={date_2}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{ inputProps: { min: date_1 } }}
              />

              {!this.validateDates() && (
                <StyledSpan>
                  * Please select End date after start date
                </StyledSpan>
              )}
              {date_2 === "" && (
                <StyledSpan>* Please select End date</StyledSpan>
              )}
              <br />
              {!isEmpty(date_1) && !isEmpty(date_2) && isEmpty(events1) && (
                <StyledSpan>No Events on the selected date</StyledSpan>
              )}
              {!isEmpty(events1) && (
                <React.Fragment>
                  <Card>
                    <Grid container spacing={8}>
                      <Grid item xs={12} sm={12}>
                        <b>Remaining activity for first bike:</b>
                      </Grid>
                    </Grid>
                    <NestedGrid events={events1} />
                  </Card>
                  {!validInterval && (
                    <StyledSpan>
                      {intervalValidity.message}
                    </StyledSpan>
                  )}
                  {!isNil(availableItems) && (
                    <React.Fragment>
                      <br />
                      <InputLabel shrink htmlFor="new-vehicle-simple">
                        Second bike *
                      </InputLabel>
                      <br />
                      <StyledSelect
                        onChange={e => this.handleItemChange(e)}
                        inputProps={{
                          name: "new_vehicle_id",
                          id: "new_vehicle_id"
                        }}
                        value={this.state.new_vehicle_id}
                      >
                        {map(vehicle => {
                          return (
                            <MenuItem value={vehicle.id} key={vehicle.id}>
                              {vehicle.licence_plate} ({vehicle.model_name} /
                              {vehicle.vehicle_color} /{" "}
                              {vehicle.vehicle_mileage} KM)
                            </MenuItem>
                          );
                        }, availableItems)}
                      </StyledSelect>
                      {new_vehicle_id === 0 && (
                        <StyledSpan>
                          Second bike is required for switch
                        </StyledSpan>
                      )}
                    </React.Fragment>
                  )}
                  {validInterval && isNil(availableItems) && <LinearProgress />}
                  {!isEmpty(events2) && (
                    <Card>
                      <br />
                      <Grid container spacing={8}>
                        <Grid item xs={12} sm={12}>
                          <b>Remaining activity for second bike:</b>
                        </Grid>
                      </Grid>
                      <NestedGrid events={events2} />
                    </Card>
                  )}
                </React.Fragment>
              )}
            </SimpleForm>
            <CardActions
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                alignContent: "right"
              }}
            >
              <SaveButton
                saving={isSubmitting}
                onClick={this.handleSaveClick}
                disabled={new_vehicle_id === 0}
              />
              <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
                <IconCancel />
              </Button>
            </CardActions>
          </CardContent>
        </Card>
      </Authenticated>
    );
  }
}

const mapStateToProps = state => ({
  isSubmitting: isSubmitting("bike-switch-update")(state)
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleSwitchActivity);



// WEBPACK FOOTER //
// ./src/components/vehicleSwithActivity.js